import { useBreakpoint } from "@brg/ui"
import { useEffect, useState } from "react";

type Placement = 'bottom-left' | 'bottom-center' | 'bottom-right' | 'top-left' | 'top-center' | 'top-right';
/**
 * 
 * @param p конечная позиция
 * @returns 
 */
export const useToastsPosition = (p: Placement) => {
    const defaultPos = 'bottom-right';
    const [pos,setPos] = useState<Placement>(defaultPos);
    const success = useBreakpoint(520);

    useEffect(() => {
        p && success && setPos(p)
            return () => setPos(defaultPos)
    }, [p, success])

    return {
        placement: pos,
    }
}import { useBreakpoint } from "@brg/ui"
import { useEffect, useState } from "react";

type Placement = 'bottom-left' | 'bottom-center' | 'bottom-right' | 'top-left' | 'top-center' | 'top-right';
/**
 * 
 * @param p конечная позиция
 * @returns 
 */
export const useToastsPosition = (p: Placement) => {
    const defaultPos = 'bottom-right';
    const [pos,setPos] = useState<Placement>(defaultPos);
    const success = useBreakpoint(520);

    useEffect(() => {
        p && success && setPos(p)
            return () => setPos(defaultPos)
    }, [p, success])

    return {
        placement: pos,
    }
}